var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("v-card-title", {
        staticClass: "d-flex justify-center",
        domProps: { textContent: _vm._s("Selected Center:") }
      }),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c("v-autocomplete", {
            attrs: {
              items: _vm.centers,
              "item-text": "name",
              label: "Select Center",
              solo: "",
              "return-object": ""
            },
            model: {
              value: _vm.selectedCenter,
              callback: function($$v) {
                _vm.selectedCenter = $$v
              },
              expression: "selectedCenter"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }